import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navItems = [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category/all' },
    { label: '建站教程', path: '/category/jianzhanjiaocheng' },
    { label: '关于我们', path: '/about' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
              <i className="ri-global-line text-lg text-background-50"></i>
            </div>
            <span className="text-lg font-bold text-foreground-950 whitespace-nowrap font-heading">
              免费建站
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  isActive(item.path)
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/all"
              className="px-5 py-2.5 rounded-full bg-transparent border border-foreground-300 text-sm font-medium text-foreground-800 hover:border-foreground-500 hover:text-foreground-950 transition-all duration-200 whitespace-nowrap"
            >
              浏览模板
            </Link>
            <a
              href="#cta"
              className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即免费建站
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className="px-4 py-4 bg-background-50/95 backdrop-blur-md border-t border-background-200/70 space-y-3">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                isActive(item.path)
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <div className="flex gap-3 pt-2">
            <Link
              to="/category/all"
              className="flex-1 px-4 py-3 rounded-full text-center border border-foreground-300 text-sm font-medium text-foreground-800 hover:border-foreground-500 transition-all"
            >
              浏览模板
            </Link>
            <a
              href="#cta"
              className="flex-1 px-4 py-3 rounded-full text-center bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all"
            >
              免费建站
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}